import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";

export enum FilterKeys {
    selectedOrganization,
    selectedFileSource,
    selectedDate
}

export enum FileSourcePullHistoryStatus {
    Processing = 0,
    Success = 1,
    PartialSuccess = 2,
    Failed = 3
}

export enum FileSourceType {
    ManagedS3 = 0,
    CustomS3 = 1,
    Sftp = 2
}

export type AtsFileSourcePullHistoryFilter = {
    organization?: string;
    source?: string;
    status?: number;
    range?: string | [];
};

export class AtsFileSourcePullHistorySearchResult extends SearchResult<AtsFileSourcePullHistory> {}

export class AtsFileSourcePullHistoryMetaData {
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
}

export class AtsFileSourcePullHistory {
    Id: string;
    FileSourceId: string;
    FileSourceName: string;
    FileSourceType: FileSourceType;
    OrganizationId: string;
    OrganizationName: string;
    Reason: string;
    TotalCount: number;
    ProcessedCount: number;
    DownloadErrorsCount: number;
    S3SaveErrorsCount: number;
    DeletionErrorsCount: number;
    DownloadErrorsFilePaths: string[];
    S3SaveErrorsFilePaths: string[];
    DeletionErrorsFilePaths: string[];
    Status: FileSourcePullHistoryStatus;
    Duration: number;
    @fromClass MetaData: AtsFileSourcePullHistoryMetaData;
}
